import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@stashinvest/ui';

const AutoStashIcon = ({ width, height, color }) => {
	const { colors } = useTheme();
	return (
		<svg
			width={width || '100%'}
			height={height || '100%'}
			viewBox="0 0 17 17"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.759 12.735c-.728.794-1.867 1.189-3.379 1.189-.32 0-.658-.018-1.004-.053-2.122-.12-5.092-.44-7.995-.81l1.227 1.752a.82.82 0 01-1.342.94L.898 12.37a.82.82 0 01.201-1.14l3.386-2.372a.82.82 0 01.94 1.342l-1.777 1.244c2.846.361 5.762.676 7.855.794 1.509.15 2.556-.072 3.05-.61a1.42 1.42 0 00.351-.798 1.59 1.59 0 00.003-.414.819.819 0 011.609-.303 3.02 3.02 0 01-.757 2.621zm-2.103-7.328c-2.836-.36-5.762-.676-7.855-.794-1.51-.15-2.557.072-3.05.61a1.413 1.413 0 00-.351.798 1.59 1.59 0 00-.003.413.818.818 0 01-.805.97v-.25.25a.819.819 0 01-.804-.668 3.013 3.013 0 01.757-2.62c.883-.963 2.368-1.337 4.383-1.135 2.122.119 5.092.44 7.995.81l-1.227-1.753a.82.82 0 011.342-.94l2.368 3.383a.82.82 0 01-.201 1.14l-3.386 2.371a.818.818 0 01-.94-1.341l1.777-1.244z"
				fillRule="nonzero"
				fill={color || colors.iconDefault}
			/>
		</svg>
	);
};

AutoStashIcon.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string,
	color: PropTypes.string,
};

export default AutoStashIcon;
